import { DynamicStandaloneFront } from '@/components/Front';
import { LabradorComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import { withDebugMetadata } from 'lib/utils';

const LabradorFront: LabradorComponent = ({ type, meta, descendants, ...props }) => {
  const className = meta.pageType ?? '';

  return (
    <DynamicStandaloneFront
      descendants={descendants}
      {...mergeProps({ className }, props)}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorFront;
